import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const Header = styled.h1`
  color: ${colors.fsDarkBlue};
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 10px;
`;

export const SubjectInput = styled.input.attrs({
  type: 'text',
})`
  padding: 0.7em;
  border: 1px solid ${colors.gray};
  margin-bottom: 15px;
  font-size: 13px;
  width: 100%;

  ${({ isEmailField }) =>
    isEmailField &&
    css`
      width: 50%;
      @media (max-width: 736px) {
        width: 100%;
        margin-bottom: 0px;
      }
    `};

  &:focus-visible {
    outline: ${colors.gray};
  }
`;

export const GridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 40px;

  @media (max-width: 736px) {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 10px;
  }
`;

export const PreviewHeading = styled.h4`
  color: ${colors.fsDarkBlue};
  margin-top: 5px;
`;

export const Section = styled.section``;

export const PreviewContainer = styled.div`
  margin-top: 20px;
`;

export const ErrorMessage = styled.p`
  color: ${colors.red};
  font-weight: 600;
  padding-top: 10px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 365px;
  border-color: ${colors.gray};
  padding: 10px;
  font-size: 14px;
  :focus-visible {
    outline: none;
  }
`;

export const TestEmailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  margin-top: 10px;
  @media (max-width: 736px) {
    margin-top: 20px;
    flex-direction: column;
  }
`;

export const SubHeader = styled.h3`
  color: ${colors.fsDarkBlue};
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 10px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
